var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "landing-page" }, [
    _c("section", { staticClass: "demo-container" }, [
      _c("div", { staticClass: "header" }, [
        _c(
          "div",
          { staticClass: "header-wrapper" },
          [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("@/assets/img/upmood_logo.svg") }
            }),
            _vm._v(" "),
            _c(
              "router-link",
              { staticClass: "login", attrs: { to: "/signin" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.$t("login")) +
                    "\n                    "
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "icon-container" }, [
          _c("div", { staticClass: "icon-wrapper" }, [
            _c("img", {
              staticClass: "icon wave",
              attrs: { src: require("@/assets/img/wave-header.svg") }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "details" }, [
          _c("h1", { staticClass: "title fix-width" }, [
            _vm._v(
              "\n\t\t\t\t\t\t" +
                _vm._s(_vm.$t("landing_success_starts")) +
                "\n                    "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "desc" }, [
            _vm._v(
              "\n                        " +
                _vm._s(_vm.$t("landing_success_starts_paragraph")) +
                "\n                    "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "login-wrapper" },
            [
              _c(
                "router-link",
                { staticClass: "login", attrs: { to: "/signin" } },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.$t("login")) +
                      "\n                        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("small", [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("or")) +
                    "\n                        "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "demo-form",
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.requestDemo()
                }
              }
            },
            [
              _c("label", { attrs: { for: "email" } }, [
                _vm._v(
                  "\n                            " +
                    _vm._s(_vm.$t("request_demo")) +
                    "\n                        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "email",
                  attrs: {
                    type: "email",
                    name: "email",
                    placeholder: "Enter email",
                    required: ""
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  { staticClass: "send", attrs: { disabled: _vm.loading } },
                  [
                    _vm._v(
                      "\n                                " +
                        _vm._s(
                          _vm.loading
                            ? _vm.$t("Loading") + "..."
                            : _vm.$t("send")
                        ) +
                        "\n                            "
                    )
                  ]
                )
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "circle orange animate-growing" }),
        _vm._v(" "),
        _c("span", { staticClass: "circle light-orange animate-growing" }),
        _vm._v(" "),
        _c("div", { staticClass: "icon-container" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: require("@/assets/img/icon/request-demo.png") }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "records-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm.$t("landing_a_new_way")) +
            "\n            "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "icon-container" }, [
            _c("img", {
              staticClass: "icon",
              attrs: {
                src: require("@/assets/img/icon/Upmood_Website Asset_Track.png")
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-content" }, [
            _c("h2", { staticClass: "item-title" }, [_vm._v("Track")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("landing_track_paragraph")))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "icon-container" }, [
            _c("img", {
              staticClass: "icon",
              attrs: {
                src: require("@/assets/img/icon/Upmood_Website Asset_Observe.png")
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-content" }, [
            _c("h2", { staticClass: "item-title" }, [_vm._v("Observe")]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.$t("landing_observe_paragraph")))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item" }, [
          _c("div", { staticClass: "icon-container" }, [
            _c("img", {
              staticClass: "icon",
              attrs: {
                src: require("@/assets/img/icon/Upmood_Website Asset_Analyze.png")
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item-content" }, [
            _c("h2", { staticClass: "item-title" }, [
              _vm._v(
                "\n                            " +
                  _vm._s(_vm.$t("landing_analyze")) +
                  "\n                        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                            " +
                  _vm._s(_vm.$t("landing_analyze_paragraph")) +
                  "\n                        "
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "how-it-works-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm.$t("landing_how_it_works")) +
            "\n            "
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("Upmood Insight")]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", { staticClass: "circle cyan animate-growing" }),
        _vm._v(" "),
        _c("span", { staticClass: "circle orange animate-growing" }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "icon-container" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: require("@/assets/img/icon/our-solution.jpg") }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "sample-data-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n                Upmood Insight Sample Data\n            ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "\n                Collected individual data can be output into either a PDF line graph or XLS raw data document. Below is an example of the\n                XLS file. Which includes, time stamps, PPi, BPM,  Stress Level, Stress Level Value, Emotion Value and Emotion Level.\n            "
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/img/icon/sample-data.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "icon-container footer-wave" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/footer-wave.png") }
        })
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "sample-data-xls-container" }, [
      _c("div", { staticClass: "icon-container footer-wave" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/footer-wave.png") }
        })
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/img/icon/sample-data-xls.png") }
      })
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "upmood-mass-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm.$t("upmood_mass")) +
            "\n            "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v("Hardware for Mass Emotion Tracking")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", { staticClass: "circle orange animate-growing" }),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "icon-container" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: require("@/assets/img/icon/upmood-mass.png") }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "upmood-app-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n                Upmood App\n            ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "Upmood Wearables can operate independently via the Upmood App, available on Android"
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "icon-container" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: require("@/assets/img/icon/upmood-app-1.jpg") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "two-part" }, [
            _c("img", {
              staticClass: "icon",
              attrs: { src: require("@/assets/img/icon/upmood-app-2.jpg") }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "icon",
              attrs: { src: require("@/assets/img/icon/upmood-app-3.jpg") }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(4),
    _vm._v(" "),
    _c("section", { staticClass: "researcher-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n                Upmood Research Leads\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "details" }, [
          _c("div", { staticClass: "lead-container" }, [
            _c("span", { staticClass: "circle cyan animate-growing" }),
            _vm._v(" "),
            _c("span", { staticClass: "circle orange animate-growing" }),
            _vm._v(" "),
            _c("div", { staticClass: "upper" }, [
              _c("img", {
                staticClass: "icon",
                attrs: { src: require("@/assets/img/icon/wong.png") }
              }),
              _vm._v(" "),
              _vm._m(5)
            ]),
            _vm._v(" "),
            _vm._m(6)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "lead-container" }, [
            _c("span", {
              staticClass: "circle opposite orange animate-growing"
            }),
            _vm._v(" "),
            _c("span", { staticClass: "circle opposite cyan animate-growing" }),
            _vm._v(" "),
            _c("div", { staticClass: "upper" }, [
              _c("img", {
                staticClass: "icon chung",
                attrs: { src: require("@/assets/img/icon/chung.png") }
              }),
              _vm._v(" "),
              _vm._m(7)
            ]),
            _vm._v(" "),
            _vm._m(8)
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "icon-container footer-wave" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/footer-wave.png") }
        })
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "api-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v(
          "\n                Upmood Mass Setup & Insight API\n            "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "demo" }, [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: require("@/assets/img/icon/Upmood Mass Set up and Insight.png")
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(9),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c("a", { staticClass: "api", on: { click: _vm.download } }, [
          _vm._v("\n                    View Upmood Mass\n                ")
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "api",
            attrs: {
              target: "_blank",
              href: "https://documenter.getpostman.com/view/5701242/VUxPtSKg"
            }
          },
          [
            _vm._v(
              "\n                    View Upmood Insight API\n                "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "ads-container" }, [
      _c("div", { staticClass: "icon-container footer-wave" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/footer-wave.png") }
        })
      ]),
      _vm._v(" "),
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n                Start your Upmood journey\n            ")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v("Get a glimpse of your emotion with a single beat!")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "links-container" }, [
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href:
                "https://play.google.com/store/apps/details?id=com.td.upmood"
            }
          },
          [
            _c("img", {
              staticClass: "icon",
              attrs: { src: require("@/assets/img/icon/google-play.png") }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("@/assets/img/icon/phones.png") }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "icon-container opposite footer-wave" }, [
        _c("img", {
          staticClass: "icon",
          attrs: { src: require("@/assets/img/icon/footer-wave.png") }
        })
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "footer-container" }, [
      _c("div", { staticClass: "footer-wrapper" }, [
        _c("div", { staticClass: "details" }, [
          _c("div", { staticClass: "item" }, [
            _c("h4", { staticClass: "item-title" }, [
              _vm._v(
                "\n                            " +
                  _vm._s(_vm.$t("about")) +
                  "\n                        "
              )
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.upmood.com/termsconditions",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.$t("terms_condition")) +
                        "\n                                "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.upmood.com/privacypolicy",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      "\n                                    " +
                        _vm._s(_vm.$t("privacy_policy")) +
                        "\n                                "
                    )
                  ]
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("h4", { staticClass: "item-title" }, [
              _vm._v(
                "\n                            " +
                  _vm._s(_vm.$t("help")) +
                  "\n                        "
              )
            ]),
            _vm._v(" "),
            _vm._m(10)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "item" }, [
            _c("h4", { staticClass: "item-title" }, [
              _vm._v(
                "\n                            " +
                  _vm._s(_vm.$t("contact_us")) +
                  "\n                        "
              )
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "\n                                Tel. " +
                    _vm._s(_vm.companyNumber) +
                    "\n                            "
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n                                Address: " +
                    _vm._s(_vm.companyAddress) +
                    "\n                            "
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(11)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("ul", [
        _c("li", [
          _vm._v("Real-time emotional state and stress level dashboard")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Collect, analyse and enrich data collected using Upmood devices"
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "\n                            Generate reports containing rich user information:\n\n                            "
          ),
          _c("ul", { staticClass: "inside" }, [
            _c("li", [_vm._v("Emotion")]),
            _vm._v(" "),
            _c("li", [_vm._v("Stress")]),
            _vm._v(" "),
            _c("li", [_vm._v("Calories burn")]),
            _vm._v(" "),
            _c("li", [_vm._v("Emotion Distribution")]),
            _vm._v(" "),
            _c("li", [_vm._v("BPM")]),
            _vm._v(" "),
            _c("li", [_vm._v("Raw PPi Data")])
          ])
        ]),
        _vm._v(" "),
        _c("li", [_vm._v("API for more efficient information sharing")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", { staticClass: "title" }, [
      _vm._v("\n                Upmood Insight Sample Data "),
      _c("br"),
      _vm._v("\n                (XLS raw Data Document)\n            ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("div", { staticClass: "up" }, [
        _c("h1", { staticClass: "sub-title" }, [_vm._v("Overview")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _vm._v(
              "Upmood Mass allows you to collect data from multiple users simultaneously"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("One station is equipped with 12 Upmood wearables")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Multiple stations can work together without limiting the number of users"
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v("The station is a charging dock for the wearables")
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Upmood Mass stations are mobile, it only requires a power bank and data network to function."
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "Upmood insight can control the station with LAN or wireless network."
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "down" }, [
        _c("div", { staticClass: "components" }, [
          _c("h1", { staticClass: "sub-title left" }, [_vm._v("Components")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("12 Upmood Wearables")]),
            _vm._v(" "),
            _c("li", [_vm._v("Cassia-E1000 Bluetooth Edge Gateway")]),
            _vm._v(" "),
            _c("li", [_vm._v("USB Charger Station")]),
            _vm._v(" "),
            _c("li", [_vm._v("Tower Body/Casing")]),
            _vm._v(" "),
            _c("li", [_vm._v("Ethernet LAN Cable")])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "specs" }, [
          _c("h1", { staticClass: "sub-title left" }, [_vm._v("Specs")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [_vm._v("Wearables have 12 hrs always-on battery life")]),
            _vm._v(" "),
            _c("li", [_vm._v("Bluetooth Low Energy 5.0")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "10-15m Radius Bluetooth range in optimal environment. (Indoors)"
              )
            ])
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details" }, [
      _c("span", { staticClass: "circle cyan animate-growing" }),
      _vm._v(" "),
      _c("span", { staticClass: "circle orange animate-growing" }),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _vm._v(
            "Emotion Tracking - Once connected with our wearables, the app can update emotion data every 90 seconds. You can simultaneously monitor BPM via the app and refreshes every 10 seconds."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Emotion Records - Through “Mood Stream” in the app users are able to access historic records of emotion and stress level changes within the app."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "Emotional Sharing - Using the insight function, users can share their data back into Upmood Insight for recording and analysis."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "insight-demo-container" }, [
      _c("h1", { staticClass: "title" }, [
        _vm._v("\n                Upmood Mass & Insight Demo\n            ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "demo" }, [
        _c("iframe", {
          staticClass: "demo-item",
          attrs: {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/jYPntWita1g",
            title: "YouTube video player",
            frameborder: "0",
            allow:
              "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name-container" }, [
      _c("p", { staticClass: "name" }, [
        _vm._v("Professor Thomas K.S. WONG, PhD, RN, JP")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "lead-title" }, [
        _vm._v(
          "President of the Ginger Knowledge Transfer and Consultancy Limited, Kyorin Chair Professor, Guangzhou University of Chinese Medicine, Nanshan Scholars Backbone Talent, Distinguished Professor of Guangzhou Medical University and Honorary Professor, the Education University of Hong Kong"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lower" }, [
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "Professor Wong is a pioneer in the development of information technology for higher education, research and practice, and was instrumental in harnessing computerized simulations, virtual reality and Web-based learning for the PolyU’s health programmes.  He and his team created the city’s first telehealth and telecare system, and have garnered many patents and major awards (three commendatory awards, nine gold medals, one silver medal, and two bronze medals in international and local competitions) for their invention. One of these was a heart rate variability monitoring and responding device which can be used for management of stress and anxiety in children."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "Prof. Wong has published widely in international research journals and is a senior member of many international health bodies such as editorial committees of SCI journals. He was chosen as one of Hong Kong’s “Ten Outstanding Young Persons” in 1991 and was made a Justice of the Peace in 2007."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "name-container" }, [
      _c("p", { staticClass: "name" }, [
        _vm._v("Professor Joanne Wai Yee CHUNG, PhD, RN.")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "lead-title" }, [
        _vm._v(
          "\n                                    Peter TC Lee Chair Professor of Health Studies, is affiliated to the Department of Health and Physical Education of The Education University of Hong Kong. "
        ),
        _c("br"),
        _vm._v(
          "\n                                    Professor Chung is a pain specialist in both research and clinical practice.  Her creativity, leadership and perseverance in research activities in the emerging and potentially lucrative field of digital health and pain study  are especially noteworthy.\n                                "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lower" }, [
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "She has been researching and developing an integrative pain management protocol for patients afflicted with cancer, chronic or idiopathic pain.  All these activities led her to many international awards in the past years.  Professor Chung also practises mindfulness and has extensive experience in the application of mindfulness in pain management and the offer of resilience building programmes.  She is a licensed trainer in Mindful Self-Compassion and Mindfulness-based Stress Reduction.   She has completed her Mindfulness Teachers (mTeachers) Training Programme by Plum Village, Mindfulness Born Peace and Happiness (MBPH): A way of well-being."
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc" }, [
        _vm._v(
          "Academically, she is also one of the pioneers in translational research particularly in the area of integrating Western medicine, traditional Chinese medicine, heart rate variability and technology for the purpose of preserving good health.  She has published extensively over 150 databased papers in many international refereed journals and obtained 16 patents, out of which two are licensed for use.  She was the awardee of the Nanshan Scholar Key Talent Scheme (December 2017) and affiliated to Guangzhou Medical University as a Distinguished Professor"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "desc" }, [
      _vm._v(
        "\n                For more information about Upmood Mass and available "
      ),
      _c("br"),
      _vm._v(
        "\n                API Functions please check this button below.\n            "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c(
          "a",
          {
            attrs: {
              href: "mailto:support@upmood.com?Subject=Request%20A%20Demo"
            }
          },
          [
            _vm._v(
              "\n                                    support@upmood.com\n                                "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", [
      _c("div", { staticClass: "social-media-wrapper" }, [
        _c(
          "a",
          {
            attrs: {
              href: "https://www.facebook.com/UpmoodApp",
              target: "blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/icon/facebook.svg"),
                alt: "facebook"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://twitter.com/Upmoodapp", target: "blank" } },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/icon/twitter.svg"),
                alt: "twitter"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "a",
          {
            attrs: {
              href: "https://www.instagram.com/upmoodapp",
              target: "blank"
            }
          },
          [
            _c("img", {
              attrs: {
                src: require("@/assets/img/icon/instagram.svg"),
                alt: "instagram"
              }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                        © Taison Digital 2018\n                    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa46d3ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa46d3ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guest/LandingPage.vue
// module id = null
// module chunks = 